import "./WatchVideo.css"; 
import { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const WatchVideo = ({ dark, MyBaseUrl }) => {

    const { slug } = useParams();
    const { state } = useLocation();

    const saved = sessionStorage.getItem("watchVideo");
    const parsed = saved ? JSON.parse(saved) : null;

    const [video, setVideo] = useState(state?.video || parsed || null);
    const [videos, setVideos] = useState([]);

    const videoRefs = useRef([]);

    const [pausedByUser, setPausedByUser] = useState({});
    const [isMuted, setIsMuted] = useState(true);

    useEffect(() => {
        fetch(`${MyBaseUrl}/posts/videos`)
            .then(res => res.json())
            .then(data => {
                const vids = data?.data?.data || [];
                setVideos(vids);

                if (!video) {
                    const found = vids.find(v => v.slug === slug);
                    setVideo(found);
                }
            })
            .catch(err => console.log(err));
    }, [slug]);

    
    const getEmbedUrl = (url) => {
        if (!url) return "";
        const id = url.split("/embed/")[1];
        return `https://www.youtube.com/embed/${id}?enablejsapi=1&playsinline=1&mute=1&controls=0`;
    };

    
    const controlVideo = (iframe, action) => {
        if (!iframe) return;

        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: "command",
                func: action,
                args: []
            }),
            "*"
        );
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = videoRefs.current.findIndex(el => el === entry.target);
                    const iframe = entry.target.querySelector("iframe");

                    if (entry.isIntersecting) {
                        if (!pausedByUser[index]) {
                            controlVideo(iframe, "playVideo");
                        }
                    } else {
                        controlVideo(iframe, "pauseVideo");
                    }
                });
            },
            { threshold: 0.7 }
        );

        videoRefs.current.forEach((el) => {
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [videos, pausedByUser]);

    
    const handleToggle = (index) => {
        const container = videoRefs.current[index];
        const iframe = container.querySelector("iframe");

        if (pausedByUser[index]) {
            controlVideo(iframe, "playVideo");

            setPausedByUser(prev => ({
                ...prev,
                [index]: false
            }));
        } else {
            controlVideo(iframe, "pauseVideo");

            setPausedByUser(prev => ({
                ...prev,
                [index]: true
            }));
        }
    };

    
    const handleUnmute = (index) => {
        const container = videoRefs.current[index];
        const iframe = container.querySelector("iframe");

        controlVideo(iframe, "unMute");

        setIsMuted(false);
    };

    if (!videos.length) return <p style={{padding: "20px"}}>Loading...</p>;

    return (
        <div className="homer">
      <Helmet>
        <title>{video?.title || 'Football Video'} | Watch Now | FadaSports</title>
        <meta name="description" content={video?.description || "Watch this exclusive football video on FadaSports."} />
        <meta name="keywords" content="football video, match highlights, video highlights, goal videos" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={video?.title || 'Football Video'} />
        <meta property="og:description" content={video?.description || "Watch this football video on FadaSports."} />
        <meta property="og:image" content={video?.image || "https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"} />
        <meta property="og:type" content="video.other" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>

            <section className="reelsWrapper">

                {videos.map((vid, index) => (

                    <div 
                        className="reel"
                        key={vid.id || index}
                        ref={(el) => (videoRefs.current[index] = el)}
                        onClick={() => handleToggle(index)}
                    >

                        <iframe
                            src={getEmbedUrl(vid?.metadata?.video_url)}
                            title={vid.title}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                        />

                        {/* 🔊 SOUND BUTTON */}
                        {isMuted && (
                            <div 
                                className="soundButton"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleUnmute(index);
                                }}
                            >
                                🔊 Tap for sound
                            </div>
                        )}

                        {/* ▶ PLAY ICON */}
                        {pausedByUser[index] && (
                            <div className="pauseOverlay">▶</div>
                        )}

                        <div className="overlay">
                            <h1>{vid.title}</h1>
                            <p>{vid.excerpt}</p>

                            <span>
                                <p>{vid.metadata?.duration}</p>
                                <p>watch video</p>
                            </span>
                        </div>

                    </div>

                ))}

            </section>


        </div>
    );
};

export default WatchVideo;